import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Receipt, Server, Headphones } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const ITEMS = [
  { icon: ShieldCheck, key: "loi25" },
  { icon: Receipt, key: "tax" },
  { icon: Server, key: "canada" },
  { icon: Headphones, key: "support" },
];

export function TrustBand() {
  const { t } = useI18n();
  return (
    <section className="relative border-y border-white/10 bg-[#080808]" data-testid="trust-band">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-5">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.key}
              className="flex items-center gap-3"
              data-testid={`trust-item-${i}`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-[#EAB308]/25 bg-[#EAB308]/[0.07]">
                <it.icon className="w-5 h-5 text-[#EAB308]" />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-white truncate">{t(`trust.${it.key}`)}</div>
                <div className="text-xs text-white/45 truncate">{t(`trust.${it.key}s`)}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
